<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Rincian Admin</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                            <div class="form-group">
                                <label class="bmd-label-floating">Nama Admin</label>
                            </div>
                            </div>
                            <div class="col-md-10 border-bottom">
                            <div class="form-group">
                                <label class="bmd-label-floating">: <span>{{data.nama}}</span></label>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                            <div class="form-group">
                                <label class="bmd-label-floating">Username</label>
                            </div>
                            </div>
                            <div class="col-md-10 border-bottom">
                            <div class="form-group">
                                <label class="bmd-label-floating">: <span v-text="data.username"></span></label>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
			
        <div class="row" v-if="data != null">
            <div class="col-md-12">
                <div class="card">
                <div class="card-header card-header-info">
                    <h4 class="card-title ">Area Admin</h4>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                                <th width="20px">No.</th>
                                <th>Area</th>
                                <th>Aksi</th>
                            </thead>
                            <tbody>
                            <tr v-for="(ser, index) in data.area">
                                <td>{{ index+1 }}</td>
                                <td>{{ ser.nama }}</td>
                                <td>
                                    <router-link :to="{ name: 'history-pembayaran', params: { id: ser.id, nama: $route.params.nama, username:data.username  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> History Pembayaran</router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
        area: [],
        username: '',
        id: '',
        nama: ''
    })
    const detail = {
      form : reactive({
        alert: null,
        alertSuccess: null
      }),
      get() {
        var datax = new FormData();
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        datax.append('id', data.id);
        
        var apiUrl = 'RincianAdmin';
        myGlobal.call(datax,apiUrl).then(x => {
            //myGlobal.loger(x);
            if (x.status == "true") {
                data.username = x.data.admin.pin;
                data.nama = x.data.admin.nama;
                data.area = x.data.area;
            } else {
            //alert(x.pesan);
            }
        })
      }
    }
    return {
      data,
      myGlobal,
      detail
    }
  },
  mounted () {
    document.title = "Rincian Admin";

    this.data.id = this.$route.params.id;

    this.detail.get();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/detail/main.vue